// extracted by mini-css-extract-plugin
export var hidden = "_71-1";
export var visible = "_71-0";